export { default } from "./CellExpiration";
